import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { object, string } from 'prop-types';
import React, { useMemo } from 'react';
import { I18n } from 'utils/i18n';

const getStyles = theme => ({
  link: {
    color: theme.palette.link.main,
    textDecoration: 'underline',
    '&:hover': {
      color: theme.palette.link.hover,
    },
  },
});

const ChatFlowCaption = ({ section, translationProps = {}, className = null, sx = null }) => {
  const theme = useTheme();
  const styles = useMemo(() => getStyles(theme), [theme]);
  const link = I18n.t(`ChatFlowSettings.${section} link`);
  return (
    <Typography
      variant="body2"
      className={className}
      sx={[
        {
          display: 'block',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {I18n.t(`ChatFlowSettings.${section} caption`, translationProps)}{' '}
      {link?.startsWith('http') ? (
        <Typography
          component="a"
          variant="body2"
          target="_blank"
          rel="noopener noreferrer"
          href={link}
          sx={styles.link}
        >
          {I18n.t('ChatFlowSettings.Learn more')}
        </Typography>
      ) : (
        ''
      )}
    </Typography>
  );
};

ChatFlowCaption.propTypes = {
  section: string.isRequired,
  translationProps: object,
  className: string,
  sx: object,
};

export default ChatFlowCaption;
